import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react';

export interface IDialogProps {
  title: string;
  onConfirm: () => void;
  body: JSX.Element | string;
  submitScheme?: string;
  submitValue?: string;
}

const defaultDialogProps: IDialogProps = {
  title: '',
  body: '',
  onConfirm: () => {},
  submitScheme: 'green',
  submitValue: 'Confimar',
};

const DialogContext = createContext<(props: IDialogProps) => void>(() => {});

export function DialogProvider({ children }: PropsWithChildren) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [data, setData] = useState(defaultDialogProps);

  const cancelRef = useRef();

  const openDialog = useCallback(
    (props: IDialogProps) => {
      setData((data) => ({ ...data, ...props }));
      onOpen();
    },
    [setData]
  );

  return (
    <DialogContext.Provider value={openDialog}>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {data.title}
            </AlertDialogHeader>

            <AlertDialogBody>{data.body}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme={data.submitScheme} onClick={data.onConfirm} ml={3}>
                {data.submitValue}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {children}
    </DialogContext.Provider>
  );
}

export function useDialog() {
  return useContext(DialogContext);
}
